// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: cuZ6tw1Eyboy

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicInterestTilePanel.module.css"; // plasmic-import: cuZ6tw1Eyboy/css

import ArrowIosLeftsvgIcon from "./icons/PlasmicIcon__ArrowIosLeftsvg"; // plasmic-import: mqQZiFLGtA/icon
import ArrowIosRightsvgIcon from "./icons/PlasmicIcon__ArrowIosRightsvg"; // plasmic-import: 5TngLItwC/icon

createPlasmicElementProxy;

export type PlasmicInterestTilePanel__VariantMembers = {};
export type PlasmicInterestTilePanel__VariantsArgs = {};
type VariantPropType = keyof PlasmicInterestTilePanel__VariantsArgs;
export const PlasmicInterestTilePanel__VariantProps =
  new Array<VariantPropType>();

export type PlasmicInterestTilePanel__ArgsType = {
  interestStack?: React.ReactNode;
};
type ArgPropType = keyof PlasmicInterestTilePanel__ArgsType;
export const PlasmicInterestTilePanel__ArgProps = new Array<ArgPropType>(
  "interestStack"
);

export type PlasmicInterestTilePanel__OverridesType = {
  interestTilePanel?: p.Flex<"div">;
  arrowLeftContainer?: p.Flex<"button">;
  interestArrowLeft?: p.Flex<"svg">;
  interestStack?: p.Flex<"div">;
  arrowRightContainer?: p.Flex<"button">;
  interestArrowRight?: p.Flex<"svg">;
};

export interface DefaultInterestTilePanelProps {
  interestStack?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicInterestTilePanel__RenderFunc(props: {
  variants: PlasmicInterestTilePanel__VariantsArgs;
  args: PlasmicInterestTilePanel__ArgsType;
  overrides: PlasmicInterestTilePanel__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"interestTilePanel"}
      data-plasmic-override={overrides.interestTilePanel}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.interestTilePanel
      )}
    >
      <button
        data-plasmic-name={"arrowLeftContainer"}
        data-plasmic-override={overrides.arrowLeftContainer}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.arrowLeftContainer
        )}
        ref={ref => {
          $refs["arrowLeftContainer"] = ref;
        }}
      >
        <ArrowIosLeftsvgIcon
          data-plasmic-name={"interestArrowLeft"}
          data-plasmic-override={overrides.interestArrowLeft}
          className={classNames(projectcss.all, sty.interestArrowLeft)}
          role={"img"}
        />
      </button>
      <p.Stack
        as={"div"}
        data-plasmic-name={"interestStack"}
        data-plasmic-override={overrides.interestStack}
        hasGap={true}
        className={classNames(projectcss.all, sty.interestStack)}
      >
        {p.renderPlasmicSlot({
          defaultContents: null,
          value: args.interestStack
        })}
      </p.Stack>
      <button
        data-plasmic-name={"arrowRightContainer"}
        data-plasmic-override={overrides.arrowRightContainer}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.arrowRightContainer
        )}
        ref={ref => {
          $refs["arrowRightContainer"] = ref;
        }}
      >
        <ArrowIosRightsvgIcon
          data-plasmic-name={"interestArrowRight"}
          data-plasmic-override={overrides.interestArrowRight}
          className={classNames(projectcss.all, sty.interestArrowRight)}
          role={"img"}
        />
      </button>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  interestTilePanel: [
    "interestTilePanel",
    "arrowLeftContainer",
    "interestArrowLeft",
    "interestStack",
    "arrowRightContainer",
    "interestArrowRight"
  ],
  arrowLeftContainer: ["arrowLeftContainer", "interestArrowLeft"],
  interestArrowLeft: ["interestArrowLeft"],
  interestStack: ["interestStack"],
  arrowRightContainer: ["arrowRightContainer", "interestArrowRight"],
  interestArrowRight: ["interestArrowRight"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  interestTilePanel: "div";
  arrowLeftContainer: "button";
  interestArrowLeft: "svg";
  interestStack: "div";
  arrowRightContainer: "button";
  interestArrowRight: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicInterestTilePanel__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicInterestTilePanel__VariantsArgs;
    args?: PlasmicInterestTilePanel__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicInterestTilePanel__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicInterestTilePanel__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInterestTilePanel__ArgProps,
          internalVariantPropNames: PlasmicInterestTilePanel__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInterestTilePanel__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "interestTilePanel") {
    func.displayName = "PlasmicInterestTilePanel";
  } else {
    func.displayName = `PlasmicInterestTilePanel.${nodeName}`;
  }
  return func;
}

export const PlasmicInterestTilePanel = Object.assign(
  // Top-level PlasmicInterestTilePanel renders the root element
  makeNodeComponent("interestTilePanel"),
  {
    // Helper components rendering sub-elements
    arrowLeftContainer: makeNodeComponent("arrowLeftContainer"),
    interestArrowLeft: makeNodeComponent("interestArrowLeft"),
    interestStack: makeNodeComponent("interestStack"),
    arrowRightContainer: makeNodeComponent("arrowRightContainer"),
    interestArrowRight: makeNodeComponent("interestArrowRight"),

    // Metadata about props expected for PlasmicInterestTilePanel
    internalVariantProps: PlasmicInterestTilePanel__VariantProps,
    internalArgProps: PlasmicInterestTilePanel__ArgProps
  }
);

export default PlasmicInterestTilePanel;
/* prettier-ignore-end */
